"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioCreationProperties1ToJSON = exports.AudioCreationProperties1FromJSONTyped = exports.AudioCreationProperties1FromJSON = exports.instanceOfAudioCreationProperties1 = void 0;
var runtime_1 = require("../runtime");
var AudioCreationStatus_1 = require("./AudioCreationStatus");
var MixProperties1_1 = require("./MixProperties1");
var ScriptProperties_1 = require("./ScriptProperties");
var VoiceoverProperties1_1 = require("./VoiceoverProperties1");
/**
 * Check if a given object implements the AudioCreationProperties1 interface.
 */
function instanceOfAudioCreationProperties1(value) {
    var isInstance = true;
    isInstance = isInstance && "voiceoverProperties" in value;
    return isInstance;
}
exports.instanceOfAudioCreationProperties1 = instanceOfAudioCreationProperties1;
function AudioCreationProperties1FromJSON(json) {
    return AudioCreationProperties1FromJSONTyped(json, false);
}
exports.AudioCreationProperties1FromJSON = AudioCreationProperties1FromJSON;
function AudioCreationProperties1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AudioCreationStatus_1.AudioCreationStatusFromJSON)(json['status']),
        'voiceoverPreviewId': !(0, runtime_1.exists)(json, 'voiceover_preview_id') ? undefined : json['voiceover_preview_id'],
        'mixPreviewId': !(0, runtime_1.exists)(json, 'mix_preview_id') ? undefined : json['mix_preview_id'],
        'generatedScriptId': !(0, runtime_1.exists)(json, 'generated_script_id') ? undefined : json['generated_script_id'],
        'toneAndFeel': !(0, runtime_1.exists)(json, 'tone_and_feel') ? undefined : json['tone_and_feel'],
        'toneAndFeelFreetext': !(0, runtime_1.exists)(json, 'tone_and_feel_freetext') ? undefined : json['tone_and_feel_freetext'],
        'brandName': !(0, runtime_1.exists)(json, 'brand_name') ? undefined : json['brand_name'],
        'adCategories': !(0, runtime_1.exists)(json, 'ad_categories') ? undefined : json['ad_categories'],
        'scriptProperties': !(0, runtime_1.exists)(json, 'script_properties') ? undefined : (0, ScriptProperties_1.ScriptPropertiesFromJSON)(json['script_properties']),
        'voiceoverProperties': (0, VoiceoverProperties1_1.VoiceoverProperties1FromJSON)(json['voiceover_properties']),
        'mixProperties': !(0, runtime_1.exists)(json, 'mix_properties') ? undefined : (0, MixProperties1_1.MixProperties1FromJSON)(json['mix_properties']),
    };
}
exports.AudioCreationProperties1FromJSONTyped = AudioCreationProperties1FromJSONTyped;
function AudioCreationProperties1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': (0, AudioCreationStatus_1.AudioCreationStatusToJSON)(value.status),
        'voiceover_preview_id': value.voiceoverPreviewId,
        'mix_preview_id': value.mixPreviewId,
        'generated_script_id': value.generatedScriptId,
        'tone_and_feel': value.toneAndFeel,
        'tone_and_feel_freetext': value.toneAndFeelFreetext,
        'brand_name': value.brandName,
        'ad_categories': value.adCategories,
        'script_properties': (0, ScriptProperties_1.ScriptPropertiesToJSON)(value.scriptProperties),
        'voiceover_properties': (0, VoiceoverProperties1_1.VoiceoverProperties1ToJSON)(value.voiceoverProperties),
        'mix_properties': (0, MixProperties1_1.MixProperties1ToJSON)(value.mixProperties),
    };
}
exports.AudioCreationProperties1ToJSON = AudioCreationProperties1ToJSON;
